import { render } from "./AddRealEstate.vue?vue&type=template&id=00c708c6&scoped=true"
import script from "./AddRealEstate.vue?vue&type=script&lang=js"
export * from "./AddRealEstate.vue?vue&type=script&lang=js"

import "./AddRealEstate.vue?vue&type=style&index=0&id=00c708c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c708c6"]])

export default __exports__